import React, { useState } from 'react';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './components/HomePage';
import PricingPage from './components/PricingPage';
import UseCasesPage from './components/UseCasesPage';
import ContactPage from './components/ContactPage';
import LiveDemo from './components/LiveDemo';
import { Page, UseCase } from './types';
import UseCaseDetailPage from './components/UseCaseDetailPage';
import AboutPage from './components/AboutPage';
import PrivacyPolicyPage from './components/PrivacyPolicyPage';
import TermsOfServicePage from './components/TermsOfServicePage';

const App: React.FC = () => {
  const [currentPage, setCurrentPage] = useState<Page>(Page.Home);
  const [selectedUseCase, setSelectedUseCase] = useState<UseCase | null>(null);

  const navigateToUseCase = (useCase: UseCase) => {
    setSelectedUseCase(useCase);
    setCurrentPage(Page.UseCaseDetail);
    window.scrollTo(0, 0);
  };
  
  const handleSetCurrentPage = (page: Page) => {
    setCurrentPage(page);
    window.scrollTo(0, 0);
  }

  const renderPage = () => {
    switch (currentPage) {
      case Page.Home:
        return <HomePage setCurrentPage={handleSetCurrentPage} />;
      case Page.Pricing:
        return <PricingPage setCurrentPage={handleSetCurrentPage} />;
      case Page.UseCases:
        return <UseCasesPage navigateToUseCase={navigateToUseCase} />;
      case Page.About:
        return <AboutPage setCurrentPage={handleSetCurrentPage} />;
      case Page.Contact:
        return <ContactPage />;
      case Page.UseCaseDetail:
        if (selectedUseCase) {
            return <UseCaseDetailPage useCase={selectedUseCase} setCurrentPage={handleSetCurrentPage} />;
        }
        return <UseCasesPage navigateToUseCase={navigateToUseCase} />;
      case Page.PrivacyPolicy:
        return <PrivacyPolicyPage />;
      case Page.TermsOfService:
        return <TermsOfServicePage />;
      default:
        return <HomePage setCurrentPage={handleSetCurrentPage} />;
    }
  };

  return (
    <div className="flex flex-col min-h-screen bg-slate-50 dark:bg-black text-slate-700 dark:text-zinc-300">
      <Header currentPage={currentPage} setCurrentPage={handleSetCurrentPage} />
      <main className="flex-grow">
        {renderPage()}
      </main>
      <Footer setCurrentPage={handleSetCurrentPage} />
      <LiveDemo />
    </div>
  );
};

export default App;